import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@ngneat/transloco';
import { SaiDialogHeaderComponent } from 'app/ui/sai-dialog-header/sai-dialog-header.component';

@Component({
    selector: 'app-core-logic-import-guidelines',
    standalone: true,
    imports: [
        SaiDialogHeaderComponent,CommonModule, MatIconModule, MatButtonModule, TranslocoModule],
    templateUrl: './core-logic-import-guidelines.component.html',
    styleUrls: ['./core-logic-import-guidelines.component.scss'],
})
export class CoreLogicImportGuidelinesComponent {
    constructor(
        private dialogRef: MatDialogRef<CoreLogicImportGuidelinesComponent>
    ) {}

    cancel(): void {
        this.dialogRef.close(false);
    }

    downloadTemplate(): void {
        this.dialogRef.close('downloadTemplate');
    }

    uploadFile(): void {
        this.dialogRef.close('upload');
    }
}
